"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const UserSerializer_1 = require("../transactions/User/UserSerializer");
const UserTransactionType_1 = require("../transactions/User/UserTransactionType");
const UserValidator_1 = require("../transactions/User/UserValidator");
class TransactionTypeResolver {
    constructor() {
        this.typeToSerializerMap = {};
        this.typeToSerializerMap[UserTransactionType_1.UserTransactionType.t] = new UserSerializer_1.UserSerializer();
        this.typeToValidatorMap = {};
        this.typeToValidatorMap[UserTransactionType_1.UserTransactionType.t] = new UserValidator_1.UserValidator();
    }
    getPayloadSerializer(transactionType) {
        if (this.typeToSerializerMap[transactionType]) {
            return this.typeToSerializerMap[transactionType];
        }
        throw new Error('Unregistered transaction type: ' + transactionType);
    }
    setPayloadSerializer(transactionType, payloadSerializer) {
        this.typeToSerializerMap[transactionType] = payloadSerializer;
    }
    getSpecificValidator(transactionType) {
        if (this.typeToValidatorMap[transactionType]) {
            return this.typeToValidatorMap[transactionType];
        }
        throw new Error('Unregistered transaction type: ' + transactionType);
    }
    setSpecificValidator(transactionType, specificValidator) {
        this.typeToValidatorMap[transactionType] = specificValidator;
    }
}
exports.TransactionTypeResolver = TransactionTypeResolver;
